import { Injectable, Injector } from '@angular/core';
import { AdiantamentoStorage, BaseResourceService,} from 'eddydata-lib';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AdiantamentoStorageService extends BaseResourceService<AdiantamentoStorage> {

  constructor(
    protected injector: Injector
  ) {
    super(`adiantamento-storages`, injector);
  }

  public upload(arquivos: any[], orgao: number, adiantamento: number, descricao?: string, foto?: boolean): Observable<AdiantamentoStorage[]> {
    const formData = new FormData();
    for (let arquivo of arquivos) {
      formData.append('files', arquivo);
    }
    if (descricao) {
      formData.append('descricao', descricao);
    }
    if (foto) {
      formData.append('foto', 'S');
    }

    const headers = this.httpOptions();
    headers.headers = headers.headers.delete('Content-Type');

    return this.http.post<AdiantamentoStorage[]>(`${this.login.cidade.id}/${this.api}/upload/${orgao}/${adiantamento}`,
      formData, headers)
      .pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }
}
